module.exports = __webpack_public_path__ + "static/img/ksc.4a8fc3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/ksc.jpg
// module id = DSY2
// module chunks = 1